import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";
import Vue from "vue";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: false,
            staleTime: Infinity,
        },
    },
})

Vue.use(VueQueryPlugin, {
    queryClient: queryClient,
})
